<template>
  <div class="winBiddingList">
    <div class="noData" v-if="nodata || searchResult || tenderLoad">
      <div class="noDataCon" v-if="nodata">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/noData.png" alt="">
        <p>暂无数据</p>
      </div>
      <div class="noDataSearch" v-else-if="searchResult">
        <h4>“{{keySearch}}”相关的搜索结果</h4>
        <p>共0个搜索结果，您可以尝试其他搜索词</p>
      </div>
      <div class="loadingBox" v-loading="tenderLoad"></div>
    </div>
    <ul class="clearfix" v-show="!tenderLoad">
      <li v-for="(item,index) in winBiddingList.bidExtList" :key="index">
        <!--<div class="winBiddingBg" v-if="item.soureType != 'PUB0003' && reminderShow">-->
          <a href="https://ep.fosunproperty.com:8888/index/group_zhblist.aspx" target="_blank" style="display:block;" v-if="index==0 && item.bulletinName==''">
            <div class="winBiddingBg businessToplogo">
            </div>
          </a>

        <div class="winBiddingBg" v-else>
          <div class="winBiddingTop">
            <h4 v-html="antiCreeping(item.bulletinName)">{{item.bulletinName}}</h4>
            <div class="agentOrg">
              <p class="winBiddingName"><span>中标企业名称：</span><b style="font-weight: normal" v-html="antiCreeping(item.agentOrgName)"></b></p>
              <p class="winBiddingTime"><span>中标公示时间：</span><b style="font-weight: normal" v-html="antiCreeping(item.publishTime,' ')"></b></p>
            </div>
          </div>
          <div class="winBiddingBottom" style="min-height: 120px; height: auto !important;">
            <p class="afficheTitle">公告内容：</p>
            <p v-html="item.content" style="position: relative;"></p>
            <div class="clearfix" v-if="item.sysDocFiles && item.sysDocFiles.length">
              <div style="width: 70px;" class="pull-left"> <span class="afficheTitle">公告附件：</span></div>
              <div style="margin-left: 70px;">
                <div v-for="file in item.sysDocFiles" :key="file.fileupdateTime">
                  <a style="padding-bottom: 5px;" :href="file.downloadUrl">{{ file.fileName && JSON.parse(file.fileName) }}</a>
                </div>
              </div>
            </div>
          </div>
          <a @click="winBiddingShow($event)" v-show="winShow" class="winBiddingBtn showBtn">展开</a>
          <a @click="winBiddingHide($event)" v-show="winHide" class="winBiddingBtn hideBtn">收起</a>
        </div>
        <!--<el-popover-->
          <!--v-else-->
          <!--popper-class="reminderHover hidden-xs"-->
          <!--placement="bottom"-->
          <!--trigger="hover">-->
          <!--<div class="reminderCon">-->
            <!--温馨提示：此项目为明源系统发布的公告，如须报名或查看项目进度，请点击公告至明源系统注册/登录进行操作。-->
            <!--<p>详询 <span class="reminderRed">400-602-7009</span></p>-->
          <!--</div>-->
          <!--<div class="winBiddingBg" slot="reference">-->
            <!--<div class="winBiddingTop">-->
              <!--<h4 v-html="antiCreeping(item.bulletinName)">{{item.bulletinName}}</h4>-->
              <!--<div class="clearfix">-->
                <!--<p class="pull-left winBiddingName"><span>中标企业名称：</span><b style="font-weight: normal" v-html="antiCreeping(item.agentOrgName)"></b></p>-->
                <!--<p class="pull-right winBiddingTime"><span>中标公示时间：</span><b style="font-weight: normal" v-html="antiCreeping(item.publishTime,' ')"></b></p>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="winBiddingBottom">-->
              <!--<p class="afficheTitle">公告内容：</p>-->
              <!--<p v-html="item.content" style="position: relative;"></p>-->
            <!--</div>-->
            <!--<a @click="winBiddingShow($event)" v-show="winShow" class="winBiddingBtn showBtn">展开</a>-->
            <!--<a @click="winBiddingHide($event)" v-show="winHide" class="winBiddingBtn hideBtn">收起</a>-->
          <!--</div>-->
        <!--</el-popover>-->
      </li>
    </ul>
  </div>
</template>
<script>
export default {
    props: ['winBiddingList','viewBussinessUrl','tenderLoad','keySearch','searchResult','nodata','reminderShow'],
    data () {
      return {
        winShow: true,
        winHide: false,
        winningNoticeInfo:{}
      }
    },
    components: {
    },
    created () {
    },
    methods: {
      winBiddingShow (e) {
        e.target.previousElementSibling.style.height="auto";
        e.target.style.display="none";
        e.target.nextElementSibling.style.display="block";
      },
      winBiddingHide (e) {
        e.target.previousElementSibling.previousElementSibling.style.height=120+"px";
        e.target.style.display="none";
        e.target.previousElementSibling.style.display="block";
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/winBiddingList/index.vue